import api from "@/_helpers/api";

export default {
  _setManagementSetup: async (context, args) => {
    const response = await api.call({
      url: `/plant/${context.state.plantId}/management/setup`,
      method: "post",
      data: args.data,
    });

    if (!response) return;

    const { result, data } = response;

    if (!result) return;

    return data;
  },

  _scheduleExport: async (context, args) => {
    const response = await api.call({
      url: `plant/${context.state.plantId}/management/exports`,
      method: "post",
      data: args.data,
    });

    if (!response) return;

    const { result, data } = response;

    if (!result) return;

    return data;
  },

  _getExportFiles: async (context) => {
    const response = await api.call({
      url: `plant/${context.state.plantId}/management/exports/files`,
      method: "get"
    });

    if (!response) return;

    const { result, data } = response;

    if (!result) return;

    return data;
  },

  _downloadExportFile: async (context, args) => {  
    
    const response = await api.call({
      url: `plant/${context.state.plantId}/management/exports/download`,
      method: "post",
      data: args.data,
      responseType: 'blob'
    });

    if (!response) return;

    //const { result } = response;

    //if (!result) return;

    // in this case I need to pass the whole response insead of data
    // because I need to pass also response headers
    return response;
  },

  _stopExportFile: async (context, args) => {  
    
    const response = await api.call({
      url: `plant/${context.state.plantId}/management/exports/stop`,
      method: "post",
      data: args.data,
    });

    

    if (!response) return;

    const { result, data } = response;

    if (!result) return;

    return data;
  },

  _deleteExportFile: async (context, args) => {  
    const response = await api.call({
      url: `plant/${context.state.plantId}/management/exports`,
      method: "delete",
      data: args.data,
    });

    if (!response) return;

    const { result, data } = response;

    if (!result) return;

    return data;
  },
 
  _setManagementSetupResend: async (context, args) => {
    const response = await api.call({
      url: `/plant/${context.state.plantId}/management/setup/resend/${args.sensorId}`,
      method: "post",
    });

    if (!response) return;

    const { result, data } = response;

    if (!result) return;

    return data;
  },
};
